import { defineMessages } from 'react-intl';

export const headlineMessages = defineMessages({
  title: {
    id: 'oauth.shared.headline.redirectHost',
    defaultMessage:
      '{requestingParty} is requesting access to your {product} account',
    description:
      'Consent headline shown at the top of the page; {requestingParty} is the app or host name',
  },
  agentTitle: {
    id: 'oauth.shared.headline.agent',
    defaultMessage:
      '{requestingParty} is requesting access to Custom Agent - "{agentName}"',
    description:
      'Agent MCP consent headline; {requestingParty} is the requesting client and {agentName} is the custom agent it wants to access',
  },
  forgeAppTitle: {
    id: 'oauth.shared.headline.forgeApp',
    defaultMessage: '{requestingParty} is requesting access to {appName}',
    description:
      'Forge MCP consent headline; {requestingParty} is the requesting agent and {appName} is the Forge app it wants to access',
  },
  customAgentInfoIconLabel: {
    id: 'oauth.shared.headline.customAgentInfoIconLabel',
    defaultMessage: 'Custom Agent information icon',
    description:
      'Label text for the icon used to display general custom agent information',
  },
  customAgentLearnMoreLink: {
    id: 'oauth.shared.headline.customAgentLearnMoreLink',
    defaultMessage: 'Learn more about Custom agents',
    description:
      'Text for the learn more link',
  },
  customAgentTooltip: {
    id: 'oauth.shared.headline.customAgentTooltip',
    defaultMessage: 'Custom agents are not built by Atlassian and Atlassian has not vetted their functionality. {learnMoreLink}',
    description:
      'Tooltip information around custom agents',
  },
  customAgentName: {
    id: 'oauth.shared.headline.customAgentName',
    defaultMessage: 'Custom Agent',
    description:
      'Fallback display name for a custom agent in Agent MCP consent when the agent has no name',
  },
});
